import React from 'react';
import { Table, TablePaginationConfig } from 'antd';
import styled from '@emotion/styled';
import { useTranslation } from 'react-i18next';
import {
  ActionsColumn,
  ActivityColumn,
  CommandColumn,
  DateTimeColumn,
  EmailColumn,
  FullNameColumn,
  IndexColumn,
  ModuleColumn,
} from './column';
import { ACTIVITY_LOG } from '../../../constants/define/translation';
import { ActivityLogInterface } from '../../../types/activityLog';
import { configFilterCommand, configFilterModule } from '../../../constants/activity/activityConstants';
import { appStyles } from '../../../styles';

const { Column } = Table;

interface ActivityLogTableProps {
  records: ActivityLogInterface[];
  loading?: boolean;
  className?: string;
  onClickViewDetail: (record?: ActivityLogInterface) => void;
  pagination?: TablePaginationConfig;
}

export const ActivityLogTable = (props: ActivityLogTableProps) => {
  const { t } = useTranslation(ACTIVITY_LOG);
  const { records, onClickViewDetail, pagination, loading, className } = props;
  return (
    <>
      <StyledTable
        dataSource={records}
        loading={loading}
        className={className}
        rowKey="id"
        pagination={pagination}
        bordered
      >
        <Column
          title={t('table.title.index')}
          align="center"
          width={70}
          dataIndex="index"
          key="index"
          render={value => <IndexColumn value={value} />}
        />
        <Column
          title={t('table.title.module')}
          align="left"
          dataIndex="module"
          key="module"
          render={module => <ModuleColumn module={module} />}
          filters={configFilterModule}
          onFilter={(value: any, record: ActivityLogInterface) => {
            return record.module === value;
          }}
        />
        <Column
          title={t('table.title.command')}
          align="left"
          dataIndex="command"
          key="command"
          render={command => <CommandColumn command={command} />}
          filters={configFilterCommand}
          onFilter={(value: any, record: ActivityLogInterface) => {
            return record.command === value;
          }}
        />
        <Column
          className="activityColumn"
          title={t('table.title.activity')}
          align="left"
          dataIndex="prevColumnValue"
          key="prevColumnValue"
          render={(prevColumnValue: any, record: ActivityLogInterface) => <ActivityColumn record={record} />}
        />
        <Column
          title={t('table.title.fullName')}
          align="left"
          dataIndex="fullName"
          key="fullName"
          render={fullName => <FullNameColumn fullName={fullName} />}
        />
        <Column
          title={t('table.title.email')}
          align="left"
          dataIndex="email"
          key="email"
          render={email => <EmailColumn email={email} />}
        />
        <Column
          title={t('table.title.modifiedAt')}
          align="left"
          dataIndex="modifiedAt"
          key="modifiedAt"
          render={dateTime => <DateTimeColumn dateTime={dateTime} />}
        />
        <Column
          title={t('table.title.action')}
          align="left"
          key="action"
          render={(_, record: ActivityLogInterface) => (
            <ActionsColumn record={record} onClickViewDetail={onClickViewDetail} />
          )}
        />
      </StyledTable>
    </>
  );
};

const StyledTable = styled(Table)`
  .ant-table-thead {
    border-bottom: 2px solid #eee;
    & > th > tr {
      ${appStyles.background.tableBgGray}
      text-transform: uppercase;
      font-size: 0.75rem;
      font-weight: 600;
      border: 1px solid #dededee3;
      &:before {
        display: none;
      }
    }
  }

  .activityColumn {
    max-width: 400px;
  }
`;
